export enum SentReply {
  None = 1,
  Automatic = 2,
  ByUser = 3,
}